// Indice lateral de las paginas de politica.
//
// El texto legal lo escribe el cliente en Settings -> Policies y no hay forma
// de meter una seccion ahi, asi que el indice se saca de los encabezados que
// ya trae el texto. Si no hay al menos dos, no se monta nada y el cuerpo se
// queda a ancho completo: mejor eso que una columna vacia.
//
// ponytail: sin scroll spy. Son enlaces a anclas; marcar el apartado activo
// pide un IntersectionObserver que aqui no paga lo que cuesta.
(function () {
  var container = document.querySelector('.shopify-policy__container');
  var body = document.querySelector('.shopify-policy__body');
  if (!container || !body) return;

  // «Last Updated: …» va en la cabecera del diseno (148:27, Manrope 13/#a2917f),
  // pero Shopify lo sirve como primer parrafo del cuerpo porque el cliente lo
  // escribe ahi. Se sube a la cabecera si aparece; si no, no se inventa fecha.
  var titleBox = document.querySelector('.shopify-policy__title');
  var firstP = body.querySelector('.rte p');
  if (titleBox && firstP && /^\s*last[\s-]*updated/i.test(firstP.textContent || '')) {
    var stamp = document.createElement('p');
    stamp.className = 'bl-policy-updated';
    stamp.textContent = firstP.textContent.trim();
    titleBox.appendChild(stamp);
    firstP.remove();
  }

  var headings = Array.prototype.slice.call(body.querySelectorAll('h2, h3'));

  // el texto suele abrir repitiendo el titulo de la pagina; en el indice eso
  // es una entrada que no lleva a ninguna parte
  var pageTitle = document.querySelector('.shopify-policy__title h1');
  var titleText = pageTitle ? pageTitle.textContent.trim().toLowerCase() : '';
  if (headings.length && titleText && headings[0].textContent.trim().toLowerCase() === titleText) {
    headings.shift();
  }

  if (headings.length < 2) return;

  var slugged = {};
  var items = headings.map(function (h, i) {
    if (!h.id) {
      var base = (h.textContent || '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '')
        .slice(0, 40) || 'section';
      slugged[base] = (slugged[base] || 0) + 1;
      h.id = slugged[base] > 1 ? base + '-' + slugged[base] : base;
    }
    // El «On This Page» del diseno va SIN numerar («Information We Collect»)
    // aunque el apartado del cuerpo si lo lleve («1. Information We Collect»).
    var label = (h.textContent || '').trim().replace(/^\d+\.\s*/, '');
    return { id: h.id, text: label || 'Section ' + (i + 1) };
  });

  // El rotulo sale de los locales, via el data- del propio <script> en
  // theme.liquid: `.shopify-policy__container` lo genera Shopify y el tema no
  // puede anadirle atributos, asi que leerlo de ahi dejaba el indice en ingles
  // tambien en /fr/ y /es/.
  var self = document.currentScript || document.querySelector('script[data-bl-toc-label]');
  var tocLabel = (self && self.dataset.blTocLabel) || 'On this page';

  var nav = document.createElement('nav');
  nav.className = 'bl-policy-toc';
  nav.setAttribute('aria-label', tocLabel);

  var title = document.createElement('h2');
  title.textContent = tocLabel;
  nav.appendChild(title);

  var list = document.createElement('ol');
  items.forEach(function (item) {
    var li = document.createElement('li');
    var a = document.createElement('a');
    a.href = '#' + item.id;
    a.textContent = item.text;
    li.appendChild(a);
    list.appendChild(li);
  });
  nav.appendChild(list);

  var grid = document.createElement('div');
  grid.className = 'bl-policy-grid';
  body.parentNode.insertBefore(grid, body);
  grid.appendChild(nav);
  grid.appendChild(body);
})();
